import client from "../Client/HttpClient";
import { ICategoriesModel } from "@/interfaces/modules";
const ApiPath = "Categories";

export default {
    GetCategories: (): Promise<ICategoriesModel[]> => client.get(`${ApiPath}`),
    GetCategoryById: (data: ICategoriesModel): Promise<ICategoriesModel> => client.get(`${ApiPath}/${data.Id}`),
    GetCategoryByKey: (key: any): Promise<ICategoriesModel[]> => client.get(`${ApiPath}/Code/${key}`),
    PostCategory: (data: ICategoriesModel): Promise<ICategoriesModel> => client.post(`${ApiPath}`, data)
};
